module.exports = __webpack_public_path__ + "static/media/order_icon16.990a6e08.png";